import apiClient from "@/apiClient";

class UserAccountService {
  static async changePassword(passwords) {
    return apiClient.put(`/api/user/password`, passwords);
  }

  static async getAvatar() {
    return apiClient.get("/api/user/avatar");
  }

  static async uploadAvatar(file) {
    const formData = new FormData();
    formData.append("avatar", file);
    return apiClient.post("/api/user/avatar", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async getTelegramStatus() {
    return apiClient.get("/api/user/telegram");
  }

  static async createTelegramLink() {
    return apiClient.post("/api/user/telegram/link");
  }

  static async disconnectTelegram() {
    return apiClient.delete("/api/user/telegram");
  }

  static async getNotificationPreferences() {
    return apiClient.get("/api/user/notification-preferences");
  }

  static async updateNotificationPreferences(preferences) {
    return apiClient.put("/api/user/notification-preferences", preferences);
  }
}

export default UserAccountService;
